import axios from "axios";
import { createHash } from "crypto";
import { getApiEndpoint } from "./api";

export const getApp: (
  clientId: string
) => "ADMIN" | "WEBSITE" | "CHAT" | null = (clientId: string) => {
  if (clientId === process.env.REACT_APP_ADMIN_CLIENT_ID) {
    return "ADMIN";
  } else if (clientId === process.env.REACT_APP_WEBSITE_CLIENT_ID) {
    return "WEBSITE";
  } else if (clientId === process.env.REACT_APP_CHAT_CLIENT_ID) {
    return "CHAT";
  } else {
    return null;
  }
};

export const isAuthorised = (clientId: string, roles: any) => {
  const app = getApp(clientId);
  console.log(app);
  if (app) {
    if (app === "WEBSITE") {
      return true;
    } else if (app === "ADMIN") {
      if (
        roles.indexOf("crs_admin") !== -1 ||
        roles.indexOf("partner_onboarding") !== -1 ||
        roles.indexOf("manager_partner") !== -1 ||
        roles.indexOf("central_booking_agent") !== -1
      ) {
        return true;
      }
    } else if (app === "CHAT") {
      if (
        roles.indexOf("zobu_chat_admin") !== -1 ||
        roles.indexOf("zobu_chat_agent") !== -1
      ) {
        return true;
      }
    }
  }
  return false;
};

export const getAppDomain: (clientId: string) => string | null = (
  clientId: string
) => {
  const app = getApp(clientId);
  if (app) {
    const domain =
      app === "ADMIN"
        ? process.env.REACT_APP_ADMIN_ROOT_DOMAIN || ""
        : app === "WEBSITE"
        ? process.env.REACT_APP_WEBSITE_ROOT_DOMAIN || ""
        : null;
    return domain;
  }
  return null;
};

export const fetchAnonymousToken: (clientId: string) => Promise<{
  token: string | null;
  tokenExpiry: string | null;
  sessionId: string | null;
}> = async (clientId) => {
  try {
    const response = await axios.post("", JSON.stringify({}), {
      baseURL: getApiEndpoint("AUTH_ANON_LOGIN"),
      headers: {
        "Content-Type": "application/json",
        "Client-App-Id": clientId,
        "Client-User-Id": createNewSession(),
      },
    });
    return {
      token: response?.data?.user_token,
      tokenExpiry: response?.data?.token_expiry,
      sessionId: response?.data.user.user_id,
    };
  } catch (error) {
    return {
      token: null,
      tokenExpiry: null,
      sessionId: null,
    };
  }
};

export const getAnonymousToken: (clientId: string) => Promise<string> = async (
  clientId
) => {
  const localAnonymousToken = localStorage.getItem("anon_token");
  const localAnonymousSession = localStorage.getItem("anon_session_id");
  const localAnonymousTokenExpiry = localStorage.getItem("anon_token_expiry");
  if (
    localAnonymousSession &&
    localAnonymousToken &&
    localAnonymousTokenExpiry &&
    +new Date() < +new Date(localAnonymousTokenExpiry)
  ) {
    return localAnonymousToken;
  } else {
    const { token, tokenExpiry, sessionId } = await fetchAnonymousToken(
      clientId
    );
    if (token && tokenExpiry && sessionId) {
      localStorage.setItem("anon_token", token);
      localStorage.setItem("anon_token_expiry", tokenExpiry);
      localStorage.setItem("anon_session_id", sessionId);
      return token;
    } else {
      return "";
    }
  }
};

export const createNewSession: () => string = () => {
  const sessionId = createHash("sha1")
    .update(
      JSON.stringify({
        timestamp: Date.now(),
        rand: Math.random() * 10000,
      })
    )
    .digest("hex")
    .substr(0, 10);
  localStorage.setItem("sessionId", sessionId);
  return sessionId;
};

export const getDeviceId = () => {
  const navigator_info = window.navigator;
  const screen_info = window.screen;
  const randomString = Math.random().toString(36).substring(2);
  let uid = navigator_info.mimeTypes.length?.toString();
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  uid += screen_info.height || "";
  uid += screen_info.width || "";
  uid += screen_info.pixelDepth || "";
  uid += navigator.platform.replace(/\D+/g, "") || "";
  uid += navigator.getGamepads()?.length || "";
  uid += navigator_info.languages.length || "";
  uid += navigator_info.hardwareConcurrency || "";
  uid += navigator_info.maxTouchPoints || "";
  return uid + randomString;
};
